import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {
  constructor(private _titleService : Title) {
    var newTitle = 'Verisource | About Us';
    this._titleService.setTitle( newTitle );
   }

  ngOnInit() {
    // console.log('fdhgfghjgjgj');
  }
}
